import { axiosConsignadoInstance } from "../axiosInstance";

export interface BatchQueueSummary {
  pending: number;
  processing: number;
  success: number;
  failed: number;
  totalQueued: number;
}

export const getBatchQueueSummary = async (): Promise<BatchQueueSummary> => {
  try {
    const response = await axiosConsignadoInstance.get(
      "/api-consignado-trabalhador/v1/balance-solicitation/batch-queue/summary"
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter resumo da fila de batch:", error);
    throw error;
  }
};

export const processBatchQueue = async (limit?: number): Promise<{ message: string }> => {
  try {
    const response = await axiosConsignadoInstance.post(
      "/api-consignado-trabalhador/v1/balance-solicitation/batch-queue/process",
      { limit }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao processar fila de batch:", error);
    throw error;
  }
};
